import { Button } from '@fl/cmsch-fe-library';
import React, { FC } from 'react';
import { WrappedFieldProps } from 'redux-form';
import { useOurTranslation } from 'app/translations';
interface Props extends WrappedFieldProps {
  title: string;
  loading?: boolean;
  toggleCriteriaListsVisibility(): void;
}

/**
 * Button used by redux-form to open the criteria list save modal.
 *
 * @param props Redux form metadata and button handlers.
 * @returns The save-criteria button.
 */
export const SaveCriteriasButton: FC<Props> = ({
  meta,
  loading,
  title,
  toggleCriteriaListsVisibility
}) => {
  const {
    t
  } = useOurTranslation('mating');
  return <Button onClick={toggleCriteriaListsVisibility} block loading={loading} disabled={meta.invalid || meta.pristine} tooltip={meta.error ? t('cantSaveParams') : undefined} testId="saveCriterias" data-sentry-element="Button" data-sentry-component="SaveCriteriasButton" data-sentry-source-file="save-criterias-button.tsx">
            {title}
        </Button>;
};